import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";

// Hook en vivo para el flag global "etiquetas desactivadas" (config/app.etiquetasOff).
// Cuando está activo:
//   · el control NO imprime/encola etiquetas
//   · la carga/entrega se puede confirmar SIN escanear
// Se usa mientras la impresora está fuera de servicio (sin tinta, etc.).
// Al ser un onSnapshot, el cambio hecho en el Panel de administración se refleja
// en todos los dispositivos en el momento, sin recargar.
export function useEtiquetasOff() {
  const [off, setOff] = useState(false);
  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, "config", "app"),
      (snap) => setOff(!!(snap.exists() && snap.data().etiquetasOff)),
      () => {} // silencioso: ante error, queda en false (comportamiento normal)
    );
    return () => unsub();
  }, []);
  return off;
}
